module.exports = __webpack_public_path__ + "img/introducePageFour_show_two.46978d99.jpg";